import * as React from "react";
import { useTranslation } from "react-i18next";
import { Field } from "formik";
import sortBy from "lodash/sortBy";
import usePluginEntities from "hooks/usePluginEntities";
import Select from "components/common/Select";
import { defaultCompare } from "logic/DefaultCompare";
const ExportFormatSelection = () => {
  const { t } = useTranslation("widgets");
  const exportFormats = usePluginEntities("views.export.formats");
  const exportFormatOptions = sortBy(
    exportFormats.sort((type1, type2) => defaultCompare(type1 == null ? void 0 : type1.displayName, type2 == null ? void 0 : type2.displayName)),
    ["order"]
  ).map(({ type, displayName, disabled = () => false }) => {
    const isDisabled = disabled();
    const title = displayName();
    return { label: title, value: type, disabled: isDisabled };
  });
  return exportFormats.length > 1 ? /* @__PURE__ */ React.createElement(Field, { name: "format" }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { htmlFor: name }, t("export.output_format")), /* @__PURE__ */ React.createElement(
    Select,
    {
      name,
      value,
      options: exportFormatOptions,
      onChange: (newFormat) => onChange({ target: { name, value: newFormat } })
    }
  ))) : null;
};
export default ExportFormatSelection;
